/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_PlatformInputs */



/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Live_Caption_PlatformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_platform = /** @type {((inputs?: Live_Caption_PlatformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_PlatformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plate-forme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Plattform")
	if (locale === "it") return /** @type {LocalizedString} */ ("Piattaforma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Платформа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plataforma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("平台")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プラットフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लैटफ़ॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Plataforma")
	return /** @type {LocalizedString} */ ("Platform")
});